/**
 * `location.pathname` from the History API is the full path (e.g. `/m3u-studio/dashboard/channel-basic`).
 * Strip Vite `BASE_URL` first, then the `/dashboard/` segment — same as a root deploy without a subpath.
 * @param baseUrl — optional override (e.g. tests); defaults to `import.meta.env.BASE_URL`.
 */
export function dashboardPageKeyFromPathname(pathname: string, baseUrl?: string): string {
  const rawBase = (baseUrl ?? (import.meta.env.BASE_URL || '/')).replace(/\/$/, '');
  let p = pathname;
  if (rawBase && (p === rawBase || p.startsWith(`${rawBase}/`))) {
    p = p.slice(rawBase.length) || '/';
  }
  if (!p.startsWith('/')) p = `/${p}`;
  const key = p.replace(/^\/dashboard\/?/, '').replace(/\/$/, '');
  return key || 'playlist-manager';
}
